import React from 'react'
import classnames from 'classnames';
import styled from 'styled-components';
import SlideLayoutPreview from "./SlideLayoutPreview";

const Container = styled.div`
  transform: ${({ open }) => open ? 'translate3d(0, 0, 0)' : 'translate3d(480px, 0, 0)' };
  transition: transform .2s;
`;

const FormPreview = ({ values, width, open }) => {

  return (
      <Container open={ open } style={ { height: 'calc(100vh - 200px)', width: width, marginTop: '60px' } } className="form-preview margin--top-doubled">
        { values.slides && values.slides.length > 0 && values.slides.map((slide, index) => {
          return (
              <div key={ index }>
                <h3>{ slide.title }</h3>
                <SlideLayoutPreview selectedColumn={ null }
                                    hideGrids
                                    layout={ slide.layout }
                                    columns={slide.layout.columns}
                                    device={ slide.layout.device }
                />
              </div>
          )
        })}

      </Container>
  );
};

export default FormPreview;



// WEBPACK FOOTER //
// ./src/containers/add/FormPreview.js